export default "__VITE_ASSET__CVFRKPUn__"